<div class="modal-container">
  <div class="modal-exit">
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
  </div>
  <div class="modal-info">
    <div class="modal-title">{{title}}</div>
    <div class="modal-text">
      {{body}}
    </div>
  </div>
  <div class="modal-buttons">
    <button type="button" class="button-white button-padding-11" (click)="onCancel()">
      {{ cancelButton ?? ('cancel' | translate) }}
    </button>
    <button type="button" class="button-red button-padding-11" (click)="onConfirm()">
      {{ confirmButton ?? ('delete' | translate) }}
    </button>
  </div>
</div>